const MAX_COL_WIDTH = 40;

// eslint-disable-next-line no-unused-vars, @typescript-eslint/no-unused-vars
class ExcelValidationError extends Error {
  constructor(message) {
    super(message);
    this.name = 'ExcelValidationError';
  }
}

async function writeXlsx(wb, fileName) {
  const buffer = await wb.writeToBuffer();
  const blob = new Blob([buffer], {
    type: 'application/octet-stream',
  });

  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.download = `${fileName}.xlsx`;
  a.href = url;
  a.click();

  URL.revokeObjectURL(url);
}

export async function saveExcel({
  fileName,
  sheetName = 'Sheet 1',
  columnNames = [],
  styles = {},
  data,
  offset = 0,
  frozenColumns = 0,
  frozenRows = 0,
}) {
  const xl = await import('excel4node');

  const wb = new xl.Workbook();
  // Note just in case: styles can pre-created via `wb.createStyle()` for performance

  const ws = wb.addWorksheet(sheetName);
  if (frozenColumns) {
    ws.column(frozenColumns).freeze();
  }
  if (frozenRows) {
    ws.row(frozenRows).freeze();
  }

  let row = 1 + offset;

  // Header
  if (columnNames.length) {
    columnNames.forEach((colName, j) =>
      ws
        .cell(row, j + 1)
        .string(colName)
        .style(styles.header || {})
    );
    row++;
  }

  let colCount = columnNames.length;
  // Content
  data.forEach((values, i) => {
    colCount = Math.max(colCount, values.length);
    values.forEach((value, j) => {
      if (value instanceof Date) {
        ws.cell(row + i, j + 1)
          .date(value)
          .style(styles.date || {});
      } else if (typeof value === 'number' || Number(value)) {
        // `Number(value)` is required to prevent "number stored as text" error
        ws.cell(row + i, j + 1)
          .number(Number(value))
          .style(styles.number || {});
      } else {
        ws.cell(row + i, j + 1)
          .string(value)
          .style(styles.text || {});
      }
    });
  });

  // Set columns width
  for (let j = 0; j < colCount; j++) {
    ws.column(j + 1).setWidth(
      Math.min(
        Math.max(
          columnNames[j]?.length || 0,
          // values can be string (text & date) or number
          ...data.map(values => String(values[j] ?? '').length),
          10
        ) + 1,
        MAX_COL_WIDTH
      )
    );
  }
  await writeXlsx(wb, fileName);
}
